import { render, staticRenderFns } from "./bulk-message-dialog.vue?vue&type=template&id=09f2071c&"
import script from "./bulk-message-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports